import { render, staticRenderFns } from "./Configuration.vue?vue&type=template&id=48d8daa9&scoped=true"
import script from "./Configuration.vue?vue&type=script&lang=js"
export * from "./Configuration.vue?vue&type=script&lang=js"
import style0 from "./Configuration.vue?vue&type=style&index=0&id=48d8daa9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d8daa9",
  null
  
)

export default component.exports